"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const debounce_1 = require("debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const ScopeGuard_1 = __importDefault(require("../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const array_1 = require("../../common/js/helper/array");
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const zuend_logo_svg_1 = __importDefault(require("../../img/zuend-logo.svg"));
const _variables_scss_1 = __importDefault(require("../../scss/_variables.scss"));
const SearchInput_1 = __importDefault(require("../atoms/SearchInput"));
const Paths = __importStar(require("../constants/Paths"));
const DataLayerEvents_1 = __importDefault(require("../enums/DataLayerEvents"));
const DataLayerLabels_1 = __importDefault(require("../enums/DataLayerLabels"));
const dataLayer_1 = require("../helper/dataLayer");
const dropdown_1 = require("../helper/dropdown");
const history_1 = require("../helper/history");
const path_1 = require("../helper/path");
const NotificationStore_1 = __importDefault(require("../stores/NotificationStore"));
const ShopwareCart_1 = __importDefault(require("../stores/ShopwareCart"));
const CompanySwitch_1 = __importDefault(require("./CompanySwitch"));
const HelpButtonTopBar_1 = __importDefault(require("./help/HelpButtonTopBar"));
const NotificationButton_1 = __importDefault(require("./notifications/NotificationButton"));
const UserButton_1 = __importDefault(require("./user_button/UserButton"));
class TopBar extends react_1.default.Component {
    mediaQueryMatcher;
    debouncedSearchInputChanged = (0, debounce_1.debounce)(this.onChangeSearchInput, 500);
    searchInputElement = null;
    cartAccessReaction;
    searchTerm = '';
    displayDesktop = false;
    showProductSuggestions = false;
    isSuggestionLoading = false;
    suggestedProducts;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            searchTerm: mobx_1.observable,
            displayDesktop: mobx_1.observable,
            showProductSuggestions: mobx_1.observable,
            isSuggestionLoading: mobx_1.observable,
            suggestedProducts: mobx_1.observable,
            showNotificationButton: mobx_1.computed,
            onShowProductSuggestions: mobx_1.action.bound,
        });
        const mobileBreakpoint = _variables_scss_1.default.menu_breakpoint;
        const minWidth = _variables_scss_1.default[`breakpoint_${mobileBreakpoint}`];
        this.mediaQueryMatcher = window.matchMedia ? window.matchMedia(`(min-width:${minWidth})`) : null;
        this.displayDesktop = this.mediaQueryMatcher?.matches ?? false;
    }
    componentDidMount() {
        this.mediaQueryMatcher?.addListener(this.mobileMediaQueryListener);
        document.addEventListener('click', this.onShowProductSuggestions);
        const matchesSearchRoute = (0, array_1.first)((0, react_router_config_1.matchRoutes)([{ path: Paths.PATH_SHOP_PRODUCTS_SEARCH }], this.props.location.pathname));
        if (matchesSearchRoute?.route.path === Paths.PATH_SHOP_PRODUCTS_SEARCH) {
            this.searchTerm = matchesSearchRoute.match.params.searchTerm ?? '';
        }
        this.cartAccessReaction = (0, mobx_1.reaction)(() => [AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.CART_READ), AuthorizationStore_1.default.customerId], ([canReadCart, customerId]) => {
            if (null === customerId) {
                ShopwareCart_1.default.reset();
            }
            if (canReadCart) {
                ShopwareCart_1.default.loadCart();
            }
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.mediaQueryMatcher?.removeListener(this.mobileMediaQueryListener);
        document.removeEventListener('click', this.onShowProductSuggestions);
        this.cartAccessReaction?.();
    }
    get showNotificationButton() {
        return NotificationStore_1.default.hasRequiredPermissions;
    }
    render() {
        return (react_1.default.createElement("div", { className: "znd-top-bar" },
            react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths.PATH_HOME), className: "znd-top-bar__link" },
                react_1.default.createElement("img", { src: zuend_logo_svg_1.default, alt: (0, translation_1.t)('main_navigation.logo_alt'), className: "znd-top-bar__logo" })),
            react_1.default.createElement("div", { className: "znd-top-bar__search-input" }, this.renderSearchBar()),
            react_1.default.createElement("div", { className: "znd-top-bar__menus" },
                react_1.default.createElement(CompanySwitch_1.default, null),
                react_1.default.createElement(HelpButtonTopBar_1.default, null),
                this.showNotificationButton ? react_1.default.createElement(NotificationButton_1.default, { className: "znd-top-bar__icon-button" }) : null,
                this.renderCartButton(),
                react_1.default.createElement(UserButton_1.default, { className: "znd-top-bar__icon-button" }))));
    }
    onChangeSearchInput() {
        (0, dataLayer_1.pushToDataLayer)({
            event: DataLayerEvents_1.default.dlvEventSearch,
            [DataLayerLabels_1.default.dlvSearch]: this.searchTerm,
        });
        this.isSuggestionLoading = true;
        (0, dropdown_1.getProductSuggestions)(this.searchTerm)
            .then((products) => {
            this.suggestedProducts = products;
        })
            .finally(() => (this.isSuggestionLoading = false));
    }
    onClearSearchInput() {
        this.searchTerm = '';
        this.suggestedProducts = undefined;
        this.showProductSuggestions = false;
    }
    renderCartButton() {
        const cartHasProducts = ShopwareCart_1.default.productsCount > 0;
        const buttonVariant = cartHasProducts ? ButtonVariant_1.default.primary : ButtonVariant_1.default.light;
        const matches = (0, react_router_config_1.matchRoutes)([{ path: Paths.PATH_SHOP_CHECKOUT }, { path: Paths.PATH_SHOP_CART }], this.props.location.pathname);
        const firstMatchedPath = (0, array_1.first)(matches)?.route.path ?? null;
        const hideFloatingActionButton = !this.displayDesktop && firstMatchedPath !== null;
        return hideFloatingActionButton ? null : (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.CART_READ] },
            react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths.PATH_SHOP_CART), className: "znd-top-bar__icon-button znd-top-bar__icon-button-shopping-cart" },
                react_1.default.createElement(Button_1.default, { variant: buttonVariant, icon: Zupicons_1.default.shoppingCart }),
                cartHasProducts ? (react_1.default.createElement("div", { className: "znd-top-bar__icon-button-shopping-cart__badge" },
                    react_1.default.createElement("span", { className: "znd-top-bar__icon-button-shopping-cart__badge__content t-body-small font-weight-bold" }, ShopwareCart_1.default.productsCount))) : null)));
    }
    renderSearchBar() {
        const matches = (0, react_router_config_1.matchRoutes)([{ path: Paths.PATH_SHOP }], this.props.location.pathname);
        const firstMatchedPath = (0, array_1.first)(matches)?.route.path ?? null;
        const showBar = firstMatchedPath === Paths.PATH_SHOP;
        return showBar ? (react_1.default.createElement(SearchInput_1.default, { setRef: (element) => {
                this.searchInputElement = element;
            }, onChange: (event) => {
                this.showProductSuggestions = true;
                // replacing of % is needed until https://github.com/ReactTraining/history/pull/656 is released in react-router
                this.searchTerm = event.target.value.replace(/[\s]+/g, ' ').replace('%', '');
                this.debouncedSearchInputChanged();
            }, onClear: this.onClearSearchInput, onFocus: () => {
                this.showProductSuggestions = true;
            }, isSuggestionLoading: this.isSuggestionLoading, onEnter: (event) => {
                event.preventDefault();
                if (this.searchTerm.length >= 2) {
                    this.suggestedProducts = undefined;
                    this.showProductSuggestions = false;
                    (0, history_1.pushHistory)(this.props.history, Paths.PATH_SHOP_PRODUCTS_SEARCH.replace(':searchTerm', encodeURIComponent(this.searchTerm)));
                }
            }, onSuggestionClick: (event, product) => {
                this.onClearSearchInput();
                if (!product?.translated?.name) {
                    return;
                }
                (0, dataLayer_1.pushToDataLayer)({
                    event: DataLayerEvents_1.default.dlvEventSearchClick,
                    [DataLayerLabels_1.default.dlvSearchClickProductTitle]: product?.translated?.name,
                });
            }, value: this.searchTerm, placeholder: (0, translation_1.t)('top_bar.search_placeholder'), suggestedProducts: this.suggestedProducts, showDropdown: this.showProductSuggestions })) : null;
    }
    mobileMediaQueryListener(matchMedia) {
        this.displayDesktop = matchMedia.matches;
    }
    onShowProductSuggestions(event) {
        if (!(event.target instanceof HTMLElement)) {
            return;
        }
        if (this.searchInputElement && this.searchInputElement.contains(event.target)) {
            return;
        }
        this.showProductSuggestions = false;
    }
}
__decorate([
    bind_decorator_1.default
], TopBar.prototype, "onChangeSearchInput", null);
__decorate([
    bind_decorator_1.default
], TopBar.prototype, "onClearSearchInput", null);
__decorate([
    bind_decorator_1.default
], TopBar.prototype, "renderCartButton", null);
__decorate([
    bind_decorator_1.default
], TopBar.prototype, "renderSearchBar", null);
__decorate([
    bind_decorator_1.default
], TopBar.prototype, "mobileMediaQueryListener", null);
exports.default = (0, react_router_dom_1.withRouter)((0, auth0_react_1.withAuth0)((0, mobx_react_1.observer)(TopBar)));
